import { Box, styled, useTheme } from '@material-ui/core';
import { SText } from '@setvi/shared/components';

export const FloatBar = styled(Box)({
  position: 'sticky',
  bottom: 12,
  width: '100%',
  marginTop: 'auto',
  zIndex: 1000,
  alignSelf: 'flex-end'
});

export const FloatBarContent = styled(Box)({
  background: '#EEF0F2',
  border: '1px solid #EEF0F2',
  borderRadius: 16,
  padding: '16px 24px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: 12
});

export const FloatBarItem = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8
});

interface QuoteFooterProps {
  sell?: number;
  cost?: number;
  quantity?: number;
  totalGrossProfit?: number;
  totalGrossProfitPercentage?: number;
}

const QuoteFooter = ({
  sell,
  cost,
  quantity,
  totalGrossProfit,
  totalGrossProfitPercentage
}: QuoteFooterProps) => {
  const { palette } = useTheme();

  return (
    <FloatBar>
      <FloatBarContent>
        <Box
          style={{
            flex: 1,
            minWidth: 250,
            display: 'flex',
            justifyContent: 'flex-end'
          }}>
          <SText title="Total" fontColor="#333D47" weight="bold" />
        </Box>
        <FloatBarItem
          style={{
            width: 200
          }}>
          <SText title="Qty" fontColor="#5D7083" weight="bold" />
          <SText
            title={quantity?.toString()}
            fontColor="#333D47"
            weight="bold"
          />
        </FloatBarItem>
        <FloatBarItem
          style={{
            width: 250
          }}>
          <SText title="Sell" fontColor="#5D7083" weight="bold" />
          <SText
            title={Number(sell)?.toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })}
            fontColor={palette?.primary.main}
            weight="bold"
          />
        </FloatBarItem>
        <FloatBarItem
          style={{
            width: 150
          }}>
          <SText title="Cost" fontColor="#5D7083" weight="bold" />
          <SText
            title={Number(cost)?.toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })}
            fontColor="#333D47"
            weight="bold"
          />
        </FloatBarItem>
        <FloatBarItem
          style={{
            width: 350
          }}>
          <SText title="GP" fontColor="#5D7083" weight="bold" />
          <SText
            title={Number(totalGrossProfit)?.toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })}
            fontColor={Number(totalGrossProfit) >= 0 ? '#23A566' : '#fc5a5a'}
            weight="bold"
          />
          <SText
            title={`(${totalGrossProfitPercentage?.toFixed(2) || 0} %)`}
            fontColor={
              Number(totalGrossProfitPercentage) >= 0 ? '#23A566' : '#fc5a5a'
            }
            weight="bold"
          />
        </FloatBarItem>
      </FloatBarContent>
    </FloatBar>
  );
};

export default QuoteFooter;
